import { useQuery } from '@tanstack/react-query';
import { getIntegrationHealth, IntegrationHealth } from '../../api/crm';

interface UseIntegrationHealthProps {
  organizationId?: string;
  enabled?: boolean;
}

/**
 * Fetch integration health (CRM connection, webhook, and owner-account signals)
 * for an organization from remi-api.
 */
export const useIntegrationHealth = ({
  organizationId,
  enabled = true,
}: UseIntegrationHealthProps) => {
  return useQuery<IntegrationHealth, Error>({
    queryKey: ['integrationHealth', organizationId],
    queryFn: () => getIntegrationHealth(organizationId as string),
    enabled: Boolean(organizationId) && enabled,
  });
};